module.exports = __webpack_public_path__ + "img/icon_2_45.dfc5a6a6.png";